import React from 'react';
import Select from 'react-select';
import { getCountries } from 'react-phone-number-input/input';
import en from 'react-phone-number-input/locale/en.json';
import ReactCountryFlag from 'react-country-flag';
import { CountryCode } from 'app/pages/admin/users/contactHelper';

interface Props {
  value?: CountryCode;
  onChange: (country: CountryCode) => void;
  disabled?: boolean;
  allowedCountries?: CountryCode[];
}

const CountryDropdown = (props: Props) => {
  const { value, onChange, disabled = false, allowedCountries = [] } = props;
  const countries = React.useMemo(() => {
    const all = getCountries();
    const filtered = allowedCountries.length
      ? all.filter(c => allowedCountries.includes(c as CountryCode))
      : all;
    return filtered.map(c => ({ value: c, label: en[c] }));
  }, [allowedCountries]);

  return (
    <Select
      value={countries.find(option => option.value === value)}
      options={countries}
      isDisabled={disabled}
      onChange={option => option && onChange(option.value as CountryCode)}
      formatOptionLabel={option => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ReactCountryFlag
            countryCode={option.value}
            svg
            style={{ width: 24, height: 16, marginRight: 8 }}
          />
          {option.label}
        </div>
      )}
      isSearchable={true}
      styles={{ menu: base => ({ ...base, width: 320 }) }}
    />
  );
};

export default CountryDropdown;
